interface NoopProps {
  children: React.ReactElement
}

function Noop({ children }: NoopProps): JSX.Element {
  return children
}

export default Noop
